import { createAction } from '@reduxjs/toolkit'
import {
    IdPosConfigurationStateDataFullItem,
    IdPosConfigurationStateDataItem,
    typePosConfigurationFilters
} from './dPosConfigurationReducer'
import {
    typeAddPosConfigurationItemObject
} from 'components/containers/dashboard/dataPosConfiguration/popupContents/popupAdd'
import {
    typeEditPosConfigurationItemObject
} from 'components/containers/dashboard/dataPosConfiguration/popupContents/popupEdit'


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dPosConfigurationSetDataAC = createAction(
    'D_POS_CONFIGURATION_SET_DATA',
    (
        dataList: IdPosConfigurationStateDataItem[],
    ) => ( { payload: { dataList } } )
)

// Action creator of saga set data
export const dPosConfigurationSetDataSagaAC = createAction(
    'D_POS_CONFIGURATION_SET_DATA_SAGA',
    (
        filters: typePosConfigurationFilters,
    ) => ( { payload: {  filters } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dPosConfigurationSetDetailItemAC = createAction(
    'D_POS_CONFIGURATION_SET_DETAIL_ITEM',
    (detailItemId: string) => ( { payload: detailItemId } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga edit item
export const dPosConfigurationEditItemSagaAC = createAction(
    'D_POS_CONFIGURATION_CHANGE_ITEM_SAGA',
    (
     itemObject: typeEditPosConfigurationItemObject,
     filters: typePosConfigurationFilters) => ( {  payload: { itemObject, filters } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga add item
export const dPosConfigurationAddItemSagaAC = createAction(
    'D_POS_CONFIGURATION_ADD_ITEM_SAGA',
    (
     itemObject: typeAddPosConfigurationItemObject,
     filters: typePosConfigurationFilters) => ( { payload: {  itemObject, filters } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga delete item
export const dPosConfigurationDeleteItemSagaAC = createAction(
    'D_POS_CONFIGURATION_DELETE_ITEM_SAGA',
    ( itemId:
         string, filters: typePosConfigurationFilters) => ( { payload: { itemId, filters } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of saga recover item
export const dPosConfigurationRecoverItemSagaAC = createAction(
    'D_POS_CONFIGURATION_RECOVER_ITEM_SAGA',
    (
     itemId: string,
     filters: typePosConfigurationFilters) => ( { payload: {  itemId, filters } } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dPosConfigurationClearFiltersAC = createAction(
    'D_POS_CONFIGURATION_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dPosConfigurationSetFiltersAC = createAction(
    'D_POS_CONFIGURATION_SET_FILTERS',
    (filtersObject: typePosConfigurationFilters) => ( { payload: filtersObject } )
)


// ---------------------------------------------------------------------------------------------------------------------
// Action creator of bulk delete saga
export const dPosConfigurationBulkDeleteSagaAC = createAction(
    'D_POS_CONFIGURATION_BULK_DELETE_SAGA',
    (
        bulkIdList: string[],
        filters: typePosConfigurationFilters) => ( { payload: { bulkIdList, filters } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set full item
export const dPosConfigurationSetFullDetailItemAC = createAction(
    'D_POS_CONFIGURATION_SET_FULL_ITEM',
    (itemObject: IdPosConfigurationStateDataFullItem) => ( { payload: itemObject } )
)
// Action creator of saga get full item
export const dPosConfigurationGetFullItemSagaAC = createAction(
    'D_POS_CONFIGURATION_GET_FULL_ITEM_SAGA',
    (
        itemId: string) => ( { payload: {  itemId }} )
)
